export default {
  account: {},
  found: false,
  inspector: {},
  person: {},
  rep: {},
  token: {},
};
